import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const campaignsApi = baseApi.injectEndpoints({
  tagTypes: ["Campaigns"],
  endpoints: (builder) => ({
    getCampaigns: builder.query({
      query: (params) => {
        return {
          url: `/campaign/get_patient_campaign_messages.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetCampaignsQuery } = campaignsApi;
